;"use strict";
document.addEventListener("DOMContentLoaded", function () {
    var html = document.documentElement;
    var body = document.body;


    // Mobile Menu Trigger
    var Burger = document.querySelector('.v-burger');
    if (Burger){
        Burger.addEventListener('click', function() {
            body.classList.toggle("v-head-open");
        });
    }

    // Sticky Nav 

    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;


    window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
        body.classList.remove(scrollUp);
        return;
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
    } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
    ) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
    });

    //dropdown

    const navs = document.querySelectorAll(".v-dropdown"),
          t = document.querySelector(".v-dropdown");
    navs.forEach(function (item) {
            item.addEventListener(
                "click",
                function () {
                    this.classList.toggle("sub-active");
                },
                !1
            );
        }),
        document.addEventListener("click", function (item) {
            item.target.closest(".v-dropdown") || t.classList.remove("sub-active");
        });



    // Search

    var searchButton = document.querySelectorAll('.v-search-button');
    var searchBox = document.querySelector('.v-search-box');
    var searchClose = document.getElementById('searchClose');
    var searchInput = document.getElementById('searchInput');
     var searchResult = document.getElementById('searchResults');

    if (typeof searchApi !== 'undefined' && searchApi != null && searchInput != null) {
        searchButton.forEach(function(sb) {
             sb.addEventListener('click', function(e) {
                 e.preventDefault();
                 searchBox.classList.add('v-search-box-visible');
                 body.classList.add('v-search-opened');
                 window.setTimeout(function() {
                     searchInput.focus();
                 }, 200);
             })
         });
         var searchinGhost = new SearchinGhost({
             key: searchApi,
             version: 'v4',
            inputId: ['searchInput'],
             outputId: ['searchResults'],
             outputChildsType: 'div',
            limit: 10,
             postsFields: ['title', 'url', 'excerpt', 'custom_excerpt', 'published_at'],
             postsExtraFields: ['tags'],
            template: function(post) {
                 var o = '';
                o += '<a href="' + post.url + '">';
                 o += '<h3 class="v-search-title"><span>' + post.title + '</span></h3> <div class="v-search-meta">';
                 o += '<time>' + post.published_at + '</time></div></a>';
                 return o;
            },
            onSearchEnd: function(posts) {
                if (searchResult.scrollHeight > searchResult.offsetHeight) {
                    searchResult.style.paddingRight = "8px";
                } else {
                     searchResult.style.paddingRight = "0px";
                }
            }
         });
         document.addEventListener('keyup', function(e) {
             if (e.keyCode == 27 && searchBox.classList.contains('v-search-box-visible') && body.classList.contains('v-search-opened')) {
               closeSearch();
             }
         });
         searchInput.addEventListener('keyup', function(e) {
             if (e.keyCode == 27) {
                 closeSearch();
             }
         });
         searchClose.addEventListener('keyup', function(e) {
             if (e.keyCode == 13) {
                 closeSearch();
             }
         });
         searchClose.addEventListener('keyup', function(e) {
             if (e.keyCode == 13) {
                 closeSearch();
             }
         });
         searchBox.onclick = closeSearch;
         searchClose.onclick = closeSearch;

         function closeSearch(e) {

             if (e !== undefined && e.target !== e.currentTarget) {
                 return;
             }
             searchBox.classList.toggle('v-search-box-visible');
             body.classList.toggle('v-search-opened');
             searchInput.value = '';
             searchResult.innerHTML = '';
         }
     }

    //pagination 
    var nextLink, nextPageUrl, loadMoreButton, endMessage;
    nextLink = document.querySelector('link[rel=next]');
    var paginationWrap = document.querySelector('.v-pagination');
    loadMoreButton = document.querySelector('.v-load-posts');
    if( nextLink !== null) {
        btnText = loadMoreButton.innerText;
        nextPageUrl = nextLink.getAttribute('href');
    }
    if( typeof(nextPageUrl) == 'undefined') {
        if(paginationWrap !== null) {
            loadMoreButton.style.display = 'none';
        }
    }
    else {
        loadMoreButton.addEventListener('click', function (e) {
            e.preventDefault();
            loadMoreButton.classList.add('loading');
            loadMoreButton.disabled = true;
            if(parseInt(pagination_next_page_number) <= parseInt(pagination_available_pages_number)){
                var url = nextPageUrl.split(/page/)[0] + 'page/' + pagination_next_page_number + '/';
                fetch(url)
                .then(function (response) {
                    if(response.ok) {
                        return response.text();
                    }
                })
                .then(function(data) {
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    var wrapper = document.querySelector('.post-feed');
                    var html = tempDiv.querySelectorAll('.main-loop');
                    for(var i=0; i < html.length; i++) {
                        wrapper.appendChild(html.item(i));
                    }
                    pagination_next_page_number++;
                    loadMoreButton.classList.remove('loading');
                    loadMoreButton.disabled = false;
                    if(pagination_next_page_number> pagination_available_pages_number) {
                        loadMoreButton.disabled = true;
                    }
                });
            }
        });
    };


});